module.exports = __webpack_public_path__ + "fonts/Formular-LightItalic.b803e0c.woff2";